export const globalPartsHistoryStartDate = new Date(2020, 0);
export const serverInputSearchDebounceDelay = 500;
export const localInputSearchDebounceDelay = 300;
export const englishAlphabet = 'abcdefghijklmnopqrstuvwxyz';
/**
 * Represents the maximum length of an error message, responded from remote api, to be shown in error components.
 *
 * If a message is larger than the limit it is to be truncated to the limit.
 */
export const maxServerErrorMessageLengthLimit = 400;
/**
 * A small space between `Select` and a `Paper` of dropdown menu.
 */
export const menuPaperTopOffset = '.25rem';
export const menuPaperTopOffsetModifier = [0, 4]; // 4px - offset should be `0.25rem `(tailwind)
// Unlike most port numbers, port 0 is a reserved port in TCP/IP networking, meaning that it should not be used in
// TCP or UDP messages. Network ports in TCP and UDP range from number zero up to 65535. Port numbers in the range
// between zero and 1023 are defined as non-ephemeral ports, system ports, or well-known ports. The Internet Assigned
// Numbers Authority (IANA) maintains an official listing of the intended usage of these port numbers on the internet,
// and system port 0 is not to be used.
export const smallestTcpPortNumber = 1;
export const highestTcpPortNumber = 65_535;
